import React from 'react';
import { Navigate, Outlet, useOutletContext } from 'react-router-dom';
import { useInscriptionState } from '../../../hooks/use-inscription-state.hook';

export const RequireStep3 = () => {
  const ctx = useOutletContext();
  const inscription = useInscriptionState();

  if (!inscription.organisme?.effectifApprenti) return <Navigate to="/inscription/etape-3" replace />;

  return <Outlet context={ctx} />;
};